module.exports = __webpack_public_path__ + "img/1 (17).ab5b09a9.jpg";